// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"838":"7d7cf225","934":"5e0c1388"}[chunkId] + ".js";
};